import { moneyFormatter } from '@/components/ui/fields/TextInput/helpers'
import { isNonNullable } from '@/typeguards/common'
import type { TTextInputFormatter } from './types'

export const formatPrice: TTextInputFormatter<string> = (value, intl) => {
  if (isNonNullable(value)) {
    return moneyFormatter(value, intl)
  }

  return value
}
